export const SHOPPING_CART_COOKIE = process.env.REACT_APP_STORAGE_KEY + 'cart'

export const getDomainName = () => window.location.hostname.includes('localhost') ? 'localhost' : '.gazin.com.br'
